var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13H15.0003L15.667 10.3334H13.3337V9.00004C13.3337 8.31337 13.3337 7.66671 14.667 7.66671H15.667V5.42671C15.4497 5.39804 14.629 5.33337 13.7623 5.33337C11.9523 5.33337 10.667 6.43804 10.667 8.46671V10.3334H8.66699V13H10.667V18.6667H13.3337V13Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.57f1c3f687c45bedf49f0965b37926a7.svg";
export { ForwardRef as ReactComponent };